import { createSuspenseQuery } from "../../utils/queryFactories.js";
import { api } from "../../utils/fetch.js";
import { z } from "zod";

export const clientStatusesResponseSchema = z.array(
  z.object({
    id: z.number(),
    value: z.string()
  })
);

type clientStatusesResponse = z.infer<typeof clientStatusesResponseSchema>;

const clientStatusesRequestSchema = z.object({
  id: z.number()
});

type clientStatusesRequest = z.infer<typeof clientStatusesRequestSchema>;

export const useclientStatusesSuspense = createSuspenseQuery<
  clientStatusesResponse,
  clientStatusesRequest,
  Error
>({
  queryKey: ["clientStatuses"],
  staleTime: 1000 * 60,
  fetcher: async (variables) => {
    return api<clientStatusesRequest, clientStatusesResponse>({
      method: "GET",
      url: `/board/:id/client-statuses`,
      requestSchema: clientStatusesRequestSchema,
      responseSchema: clientStatusesResponseSchema,
      body: variables
    });
  }
});
